(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
// Function to handle scroll events
function handleScroll() {
  // Ignore when search is open
  if (document.body.classList.contains('search-open')) return;

  const header = document.querySelector('.section-header');
  if (!header) return;

  const headerHeight = header.offsetHeight;
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (scrollTop > headerHeight + 60) {
    header.classList.add('sticky-h', 'shopify-section-header-show');
    header.classList.remove('shopify-section-header-hide');
  } else if (scrollTop > headerHeight) {
    header.classList.remove('sticky-h', 'shopify-section-header-show');
    header.classList.add('shopify-section-header-hide');
  } else {
    header.classList.remove('sticky-h', 'shopify-section-header-show', 'shopify-section-header-hide');
  }
}
window.addEventListener('scroll', handleScroll);
handleScroll();

  } catch(e) { console.error(e); }
})();
})();
